// Dados Estruturados e Sumário de Tópicos (somente na página de post)

if( document.querySelector('.conteudo-post .texto-post') != null ) {
    let titulos = document.querySelectorAll('.texto-post h2, .texto-post h3, .texto-post h4, .texto-post h5, .texto-post h6');

    // Criação do Sumário
    function removerAcentos(texto) {
        return texto.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    }
    let lista_titulos = {}
    titulos.forEach(titulo => {
        let id = removerAcentos(titulo.textContent).replace(/[^\w\s]/g, "").replace(/\s+/g, "-").toLowerCase();
        titulo.setAttribute('id', id);
        lista_titulos[titulo.textContent] = id;
    })
    let sumario = document.createElement('ul');
    sumario.setAttribute('id', 'sumario-post');
    sumario.className = 'sumario-post my-3 accordion accordion-item rounded-0';
    let sumarioTitulo = document.createElement('h3');
    sumarioTitulo.className = 'accordion-header';
    sumario.appendChild(sumarioTitulo);
    sumarioButton = document.createElement('button');
    sumarioButton.className = 'accordion-button collapsed d-flex rounded-0';
    sumarioButton.setAttribute('type', 'button');
    sumarioButton.setAttribute('data-toggle', 'collapse');
    sumarioButton.setAttribute('data-target', '#sumario-post-collapse');
    sumarioButton.setAttribute('aria-expanded', 'false');
    sumarioButton.setAttribute('aria-controls', 'sumario-post-collapse');
    sumarioButton.textContent = 'Explore os tópicos';
    sumarioTitulo.appendChild(sumarioButton);
    let sumarioCollapse = document.createElement('div');
    sumarioCollapse.className = 'accordion-collapse collapse';
    sumarioCollapse.setAttribute('id', 'sumario-post-collapse');
    sumario.appendChild(sumarioCollapse);
    let sumarioBody = document.createElement('div');
    sumarioBody.className = 'accordion-body bg-gray-50';
    sumarioCollapse.appendChild(sumarioBody);

    if (document.getElementById('content').classList.contains('pagina-post')) {
        if(document.querySelector('.conteudo-post .imagem-post') ) {
            document.querySelector('.conteudo-post .imagem-post').insertAdjacentElement( 'afterend', sumario );
        } else {
            document.querySelector('.conteudo-post').insertAdjacentElement( 'afterbegin', sumario );
        }
    }
    Object.keys(lista_titulos).forEach(titulo => {
        let li = document.createElement('li');
        li.className = 'mb-1 fs-5';
        let a = document.createElement('a');
        a.setAttribute('href', '#' + lista_titulos[titulo]);
        a.textContent = titulo;
        li.append(a);
        sumarioBody.append(li);
    })	

    // Dados Estruturados - Criação do schema FAQPage
    let lista_faq_post = {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": []
    }
    titulos.forEach(titulo => {
        if (titulo.textContent.indexOf('?') > -1 && (titulo.nextElementSibling != null && titulo.nextElementSibling.tagName == 'P')) {
            let question = {
                "@type": "Question",
                "name": titulo.textContent,
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": titulo.nextElementSibling.textContent
                }
            }
            lista_faq_post.mainEntity.push(question);
        }
    })
    // Criação do script somente se houver perguntas
    if (lista_faq_post.mainEntity.length > 0) {
        let newScript = document.createElement('script');
        newScript.setAttribute('type', 'application/ld+json');
        newScript.innerHTML = JSON.stringify(lista_faq_post);
        document.head.appendChild(newScript);
    }

    // Dados Estruturados - Criação do schema HowTo
    let lista_howto_post = {
        "@context": "https://schema.org",
        "@type": "HowTo",
        "name": document.querySelector('.titulo-post').textContent,
        "step": []
    }
    // Cada step é captado pelos headings do post que contenham a palavra Como
    titulos.forEach((passo, index) => {
        if (passo.textContent.indexOf('Como') > -1) {
            // Caso o passo não tenha um id, ele é criado
            if (passo.getAttribute('id') == null) {
                passo.setAttribute('id', 'passo-' + (index + 1));
            }
            let step = {
                "@type": "HowToStep",
                "name": passo.textContent,
                "text": passo.nextElementSibling.textContent,
                "url": window.location.href + '#' + passo.getAttribute('id')
            }
            lista_howto_post.step.push(step);
        }
    })
    // Criação do script somente se houver passos
    if (lista_howto_post.step.length > 0) {
        let newScript2 = document.createElement('script');
        newScript2.setAttribute('type', 'application/ld+json');
        newScript2.innerHTML = JSON.stringify(lista_howto_post);
        document.head.appendChild(newScript2);
    }

    // Dados Estruturados - Criação do schema ListItem
    let lista_listitem_post = {
        "@context": "https://schema.org",
        "@type": "ListItem",
        "itemListElement": []
    };

    // Para cada heading com 'Qual' ou 'Quais', busca uma UL ou OL antes do próximo heading
    titulos.forEach((listitem) => {
        if (listitem.textContent.includes('Qual') || listitem.textContent.includes('Quais')) {
            let nextElement = listitem.nextElementSibling;
            let list = [];

            while (nextElement && !/^H\d$/i.test(nextElement.tagName)) {
                if (nextElement.tagName === 'UL' || nextElement.tagName === 'OL') {
                    let items = nextElement.querySelectorAll('li');
                    items.forEach(item => {
                        list.push(item.textContent.trim());
                    });
                    break; // pegou a primeira lista após o heading e antes do próximo heading
                }
                nextElement = nextElement.nextElementSibling;
            }

            if (list.length > 0) {
                let item = {
                    "@type": "ListItem",
                    "name": listitem.textContent.trim(),
                    "item": list
                };
                lista_listitem_post.itemListElement.push(item);
            }
        }
    });

    // Criação do script somente se houver listitems
    if (lista_listitem_post.itemListElement.length > 0) {
        let newScript3 = document.createElement('script');
        newScript3.setAttribute('type', 'application/ld+json');
        newScript3.innerHTML = JSON.stringify(lista_listitem_post);
        document.head.appendChild(newScript3);
    }
}

// Corrige a url da referência caso tenha . no final
document.addEventListener("DOMContentLoaded", function () {
    let referencias = document.querySelectorAll('#collapse-referencias-conteudo .link-referencia');
    referencias.forEach(referencia => {
        if (referencia.getAttribute('href').endsWith('.')) {
            referencia.setAttribute('href', referencia.getAttribute('href').slice(0, -1));
        }
    })
});

// CTA Header Fixo - Controle de visibilidade
document.addEventListener('DOMContentLoaded', function () {
    const ctaHeaderFixo = document.querySelector('.cta-header-fixo');
    const tituloPost = document.querySelector('.titulo-post');

    if (ctaHeaderFixo && tituloPost) {
        // Observer para detectar quando passamos pelo título
        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                // Se o título saiu da tela (não está visível)
                if (!entry.isIntersecting) {
                    ctaHeaderFixo.classList.add('active');
                } else {
                    // Se o título voltou a estar visível
                    ctaHeaderFixo.classList.remove('active');
                }
            });
        }, {
            // Configurações do observer
            root: null, // viewport
            rootMargin: '0px',
            threshold: 0 // dispara quando o elemento sai completamente da tela
        });

        // Observa o título do post
        observer.observe(tituloPost);

        // Controle de scroll para mostrar/esconder CTA (similar ao menu-sections do Tamarine)
        let ultimoScrollCtaFixo = 0;
        window.addEventListener('scroll', function () {
            const atualScroll = window.scrollY;

            // Só aplica a lógica se o CTA estiver ativo (após passar pelo título)
            if (ctaHeaderFixo.classList.contains('active')) {
                if (atualScroll < ultimoScrollCtaFixo) {
                    // Rolagem para cima - mostra o CTA
                    ctaHeaderFixo.classList.add('visible');
                } else {
                    // Rolagem para baixo - esconde o CTA
                    ctaHeaderFixo.classList.remove('visible');
                }
            }
            ultimoScrollCtaFixo = atualScroll;
        });
    }
});